module.exports = __webpack_public_path__ + "static/img/feedbacck.1c0b210f.png";